<template>
  <div class="body">
    <div class="body-logo">
      <img :src="big.filepath" />
    </div>
    <div class="body-navs">
      <div v-for="(item, i) in navs"
           :key="i"
           :class="{ 'body-navs-nav': true, 'body-navs-navOn': index == i }"
           @click="onChangeNav(i)">
        {{item.name}}
      </div>
    </div>
    <div class="body-content"
         v-show="index == 0">
      <div class="body-content-box4">
        <div class="body-content-box4-img">
          <img :src="about.filepath" />
        </div>
        <div class="body-content-box4-context">
          <div class="body-content-box4-context-title">
            {{about.name}}
          </div>
          <div class="body-content-box4-context-msg">
            <div class="alone_con"
                 v-html="about.content"></div>
          </div>

        </div>
      </div>
    </div>
    <div class="body-content"
         v-show="index == 1">
      <div class="body-content-box6">
        <div class="body-content-box6-img">
          <img src="~@/assets/images/pic4.png" />
        </div>
        <div class="body-content-box6-form">

          <div class="body-content-box6-form-title">建议与投诉</div>
          <div class="body-content-box6-form-content">
            <div class="body-content-box6-form-content-item"
                 style="width: 50%">
              <div class="body-content-box6-form-content-item-title">
                <div>姓名<i>*</i></div>
              </div>
              <div class="body-content-box6-form-content-item-input">
                <input v-model="form.name" />
              </div>
            </div>
            <div class="body-content-box6-form-content-item"
                 style="width: 50%">
              <div class="body-content-box6-form-content-item-title">
                <div>手机号码<i>*</i></div>
              </div>
              <div class="body-content-box6-form-content-item-input">
                <input v-model="form.phone"
                       maxlength="11" />
              </div>
            </div>
            <div class="body-content-box6-form-content-item"
                 style="width: 50%">
              <div class="body-content-box6-form-content-item-title">
                <div>邮箱</div>
              </div>
              <div class="body-content-box6-form-content-item-input">
                <input v-model="form.email" />
              </div>
            </div>
            <div class="body-content-box6-form-content-item"
                 style="width: 50%">
              <div class="body-content-box6-form-content-item-title">
                <div>类型</div>
              </div>
              <div class="body-content-box6-form-content-item-input">
                <input v-model="form.type" />
              </div>
            </div>
            <div class="body-content-box6-form-content-item"
                 style="width: 100%">
              <div class="body-content-box6-form-content-item-title">
                <div>填写内容<i>*</i></div>
              </div>
              <div class="body-content-box6-form-content-item-input">
                <input v-model="form.context" />
              </div>
            </div>
          </div>
          <div class="body-content-box6-form-btn">
            <el-button @click="handleSubmit"
                       :disabled="disabled">提交</el-button>
          </div>
          <!-- 表单 -->

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getchild, getalone, addmsg } from "@/service/index";
export default {
  components: {},
  data () {
    return {
      index: 0,
      id: 19,
      big: [],
      navs: [],
      about: [],

      fileList: [],

      form: {
        name: "",
        phone: "",
        email: "",
        type: "",
        context: "",
        classid: 1,
      },
      disabled: false,

    };
  },
  mounted () {
    this.getchild(5);
    this.getalone();
  },
  methods: {
    getchild (cateid) {
      getchild({ cateid: cateid }).then(res => {
        this.big = res.data.big;
        this.navs = res.data.menu;
      });
    },
    getalone () {
      getalone({ id: this.id }).then(res => {
        console.log(res)
        this.about = res.data;
      })
    },
    onChangeNav (index) {
      this.index = index;
    },


    handleSubmit () {
      const { name, phone, email, type, context } = this.form;
      if (name == '') {
        this.$notify.error({
          title: '错误',
          message: '姓名不能为空'
        });
        return false;
      }
      if (phone == '') {
        this.$notify.error({
          title: '错误',
          message: '手机号不能为空'
        });
        return false;
      }
      if (context == '') {
        this.$notify.error({
          title: '错误',
          message: '内容不能为空'
        });
        return false;
      }
      addmsg(this.form).then(res => {
        if (res.code == 0) {
          this.disabled = true
          this.$message({
            message: '您的反馈提交已成功',
            type: 'success'
          });
          setTimeout(() => {
            window.location.reload();
          }, 1500)
        } else {
          this.$notify.error({
            title: '错误',
            message: res.msg
          });
          return false;
        }
      });
      console.log(name, phone, email, type, context);

    },


  },
};
</script>
<style scoped lang="scss" src="./index.scss">
</style>
